import React from 'react';
import { useCart } from '../context/CartContext';
import { Link } from 'react-router-dom';
import './CartSlideout.css';

const CartSlideout = () => {
  const { 
    cart, 
    isCartOpen, 
    closeCart, 
    removeFromCart, 
    updateQuantity, 
    getCartTotal 
  } = useCart();

  const total = getCartTotal();
  const totalDollars = (total / 100).toFixed(2);

  if (!isCartOpen) return null;

  return (
    <>
      <div className="cart-overlay" onClick={closeCart}></div>
      <div className="cart-slideout">
        <div className="cart-header">
          <h3>Shopping Cart ({cart.length})</h3>
          <button className="cart-close" onClick={closeCart}>×</button>
        </div>

        {cart.length === 0 ? (
          <div className="empty-cart">
            <p>Your cart is empty</p>
            <Link to="/shop" className="continue-shopping" onClick={closeCart}>
              Continue Shopping
            </Link>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {cart.map((item, index) => (
                <div key={index} className="cart-item">
                  <img src={item.image} alt={item.title} />
                  <div className="cart-item-details">
                    <h4>{item.fullTitle || item.title}</h4>
                    <p className="cart-item-price">{item.price}</p>
                    {item.selectedSize && (
                      <p className="cart-item-size">
                        {item.selectedSize} - {item.selectedType === 'somerset' ? 'Somerset Giclée' : 'Canvas Giclée'}
                      </p>
                    )}
                    
                    {item.category === 'Prints' && (
                      <div className="quantity-controls">
                        <button 
                          onClick={() => updateQuantity(index, item.quantity - 1)}
                          className="quantity-btn"
                        >
                          -
                        </button>
                        <span className="quantity">{item.quantity}</span>
                        <button 
                          onClick={() => updateQuantity(index, item.quantity + 1)}
                          className="quantity-btn"
                        >
                          +
                        </button>
                      </div>
                    )}
                  </div>
                  <button 
                    className="remove-item"
                    onClick={() => removeFromCart(index)}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>

            <div className="cart-footer">
              <div className="cart-subtotal">
                <span>Subtotal</span>
                <span>${totalDollars}</span>
              </div>
              <p className="cart-note">
                Tax included, shipping calculated at checkout
              </p>
              <Link to="/checkout" className="checkout-btn" onClick={closeCart}>
                Proceed to Checkout
              </Link>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CartSlideout; 